import apiPath from "../constants/api-path.constant";

import axios from "../configs/axios-instances";

const bookingApi = {
  getCustomerBooking: ({
    payload,
    page,
    limit,
    status,
    type,
    success,
    error,
  }) => {
    const {
      booking: { getCustomerBooking },
    } = apiPath;
    const queryParams = [];
    if (page !== undefined && page !== null) queryParams.push(`page=${page}`);
    if (limit !== undefined && limit !== null)
      queryParams.push(`limit=${limit}`);
    if (status) queryParams.push(`status=${status}`);
    if (type) queryParams.push(`type=${type}`);

    const pathWithParams =
      queryParams.length > 0
        ? `${getCustomerBooking}?${queryParams.join("&")}`
        : getCustomerBooking;
    axios.getRequest({ path: pathWithParams, success, error });
  },
  getAttachment: ({ payload, success, error }) => {
    const {
      booking: { getAttachment },
    } = apiPath;

    axios.postRequest({
      path: getAttachment,
      payload,
      success,
      error,
    });
  },
  getTicket: ({ payload, success, error }) => {
    const {
      booking: { ticketPage },
    } = apiPath;

    axios.postRequest({
      path: ticketPage,
      payload,
      success,
      error,
    });
  },
  resendTicket: ({ payload, success, error }) => {
    const {
      booking: { resendTicket },
    } = apiPath;

    axios.postRequest({
      path: resendTicket,
      payload,
      success,
      error,
    });
  },
  getQR: ({ payload, success, error }) => {
    const {
      booking: { getQrCode },
    } = apiPath;

    axios.postRequest({
      path: getQrCode,
      payload,
      success,
      error,
    });
  },

  verifyQR: ({ payload, success, error }) => {
    const {
      booking: { verifyQrCode },
    } = apiPath;

    axios.postRequest({
      path: verifyQrCode,
      payload,
      success,
      error,
    });
  },
  ScannerVerifyQR: ({ payload, success, error }) => {
    const {
      booking: { scannerVerifyQrCode },
    } = apiPath;

    axios.postRequest({
      path: scannerVerifyQrCode,
      payload,
      success,
      error,
    });
  },
  ScannerPreviewQr: ({ payload, success, error }) => {
    const {
      booking: { previewQrCode },
    } = apiPath;

    axios.postRequest({
      path: previewQrCode,
      payload,
      success,
      error,
    });
  },
  ScannerConfirmScan: ({ payload, success, error }) => {
    const {
      booking: { confirmScan },
    } = apiPath;

    axios.postRequest({
      path: confirmScan,
      payload,
      success,
      error,
    });
  },
};

export default bookingApi;
